import $ from 'jquery';

const $visualOptions = $('.intel-signup-options');
const $form = $('#DailyCurrencyMarketAnalysis').parents('form');

$visualOptions.find('input').each((_, npt) => {
  $(npt).on('keydown click', e => {
    const { id } = e.target;
    const checked = $(e.target).is(':checked');
    const $daily = $($form).find('#DailyCurrencyMarketAnalysis');
    const $monthly = $($form).find('#MonthlyCurrencyOutlook');

    if (id.indexOf('daily') > -1) {
      $daily.prop('checked', checked).trigger('change');
    } else {
      $monthly.prop('checked', checked).trigger('change');
    }
  });
});

$form.on('submit', e => {
  e.preventDefault();
  // Add submission code and ajax
})
